module.exports = function getResource(label, vars = []) {
    const resources = {
        thisCardHasExpired: 'Cette carte est expirée. Veuillez effectuer une mise à jour des renseignements de votre carte.',
        defaultCreditCard: 'Carte par défaut',
        makeDefaultCreditCard: 'Définir comme carte par défaut',
        edit: 'Modifier',
        addCreditCard: 'Ajoutez une carte de crédit ou de débit',
        cardDescText: `${vars[0]} terminant en ${vars[1]}`,
        cardExpirationText: `Expiration ${vars[0]} ${vars[1]}`,
        debitCardDisclaimer: 'Cartes de débit Visa et Mastercard seulement',
        gotIt: 'Compris'
    };
    return resources[label];
};
